/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from "@irian-ro/abstract-resource";

export class ActionDefinitionDtoModel extends JSONable {

  uuid: string | undefined = undefined;

  actionCost: string | undefined = undefined;

  actionName: string | undefined = undefined;

  validFrom: string | undefined = undefined;

  validTo: string | undefined = undefined;

  monthlyIncludedAmount: string | undefined = undefined;

  allowExtra: boolean | undefined = undefined;

}
